import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { trackPageView } from '../utils/analytics';

// Отправляет просмотр страницы при каждой смене маршрута.
// Без этого ни GA4, ни Метрика не видят SPA-навигацию — только первую загрузку.
// Обязательно вызывать внутри <BrowserRouter>.
export function usePageView() {
  const { pathname, search } = useLocation();

  useEffect(() => {
    // Заголовок ставит react-helmet-async в своём эффекте, поэтому читаем
    // document.title на следующем кадре — иначе уедет title предыдущей страницы
    const frame = requestAnimationFrame(() => {
      trackPageView(pathname + search, document.title);
    });

    return () => cancelAnimationFrame(frame);
  }, [pathname, search]);
}
